"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingInputsIntermediateFieldSchema = exports.QueryVariableSchema = exports.FullFormulaConfigSchema = exports.FormulaConfigSchema = void 0;
// Shared types and schemas used across multiple Config modules
const _imports_1 = require("./_imports");
exports.FormulaConfigSchema = _imports_1.z.object({
    engineVersion: _imports_1.z.enum(_imports_1.FormulaEngine.SupportedFormulaEngines),
    formula: _imports_1.z.string(),
});
exports.FullFormulaConfigSchema = _imports_1.z.object({
    engineVersion: _imports_1.z.enum(_imports_1.FormulaEngine.FullSupportedFormulaEngines),
    formula: _imports_1.z.string(),
});
// QueryVariable schema - used across multiple modules
exports.QueryVariableSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    value: _imports_1.z.string(),
    parseNumber: _imports_1.z.boolean(),
});
// Intermediate field schema for Reporting.Inputs
const CalcFormulaConfigSchema = exports.FormulaConfigSchema.extend({
    type: _imports_1.z.literal('formula'),
});
exports.ReportingInputsIntermediateFieldSchema = _imports_1.z.object({
    field: _imports_1.z.string(),
    config: CalcFormulaConfigSchema,
});
//# sourceMappingURL=_shared.js.map